import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
@Injectable()
export class HttpReqInterceptor implements HttpInterceptor {
  constructor(
    private _auth: OAuthService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
   // if(request.url.indexOf(environment.apiUrl)>= 0){
      const token = this._auth.getAccessToken();
      if(token){
        const modifiedRequest = request.clone({
          headers: request.headers.set('Authorization', 'Bearer ' + this._auth.getAccessToken()),
        });
        return next.handle(modifiedRequest);
      }
    // }
    return next.handle(request);
  }
}
